export class CommonApiService {
  constructor(http) {
    this.endpoint = '/common/';
    this.http = http;
  }

  async getProfile() {
    const { data } = await this.http.get(this.endpoint + 'profile/');
    return this.serialize(data);
  }

  async updateProfile(data) {
    const body = this.deserialize(data);
    return await this.http.put(this.endpoint + 'profile/', body);
  }

  deserialize(form) {
    const phone = form.phone ? '+7' + form.phone : '';
    return {
      avatar: form.avatar,
      date_of_birth: form.birthDay,
      gender: form.gender,
      email: form.email,
      first_name: form.firstName,
      last_name: form.lastName,
      middle_name: form.middleName,
      phone
    };
  }

  serialize(data) {
    const phone = data.phone ? data.phone.slice(2) : '';
    return {
      avatar: data.avatar,
      birthDay: data.date_of_birth,
      gender: data.gender,
      email: data.email,
      lastName: data.last_name,
      firstName: data.first_name,
      middleName: data.middle_name,
      phone
    };
  }
}
